export default __webpack_public_path__ + "c65d7d70f67369d1ee732f61679df3da.jpg";